package com.solevo.dist.network.firebase.api.notifications.models

import com.solevo.dist.application.models.MessageType
import com.solevo.dist.application.models.Notification
import com.solevo.dist.application.models.NotificationStatus
import com.solevo.dist.application.models.NotificationType
import com.solevo.dist.network.implementation.firebase.utils.time.toKotlinInstant
import dev.gitlive.firebase.firestore.Timestamp
import kotlinx.serialization.Serializable

@Serializable
data class FirebaseNotification(
    var notificationId: String? = null,
    var title: String? = null,
    var subtitle: String? = null,
    var message: String? = null,
    val messageType: MessageType? = null,
    var contactId: String? = null,
    val legalEntityId: String? = null,
    var requestId: String? = null,
    var status: NotificationStatus? = NotificationStatus.New,
    var timestamp: Timestamp? = Timestamp.now(),
    var classification: NotificationType? = null,
    val image: String? = null,
)

fun FirebaseNotification.toNotification(): Notification {
    return Notification(
        notificationId = notificationId,
        title = title,
        subtitle = subtitle,
        message = message,
        messageType = messageType,
        contactId = contactId,
        legalEntityId = legalEntityId,
        requestId = requestId,
        status = status,
        timestamp = timestamp?.toKotlinInstant(),
        classification = classification,
        image = image
    )
}

